import './TableReplenishments.css'

import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import useSyncScroll from 'utils/useSyncScroll'

import TableReplenishmentsHeader from './TableReplenishmentsHeader'
import TableReplenishmentsRow from './TableReplenishmentsRow'

const TableReplenishments = ({
  headerClassName,
  itemHeight,
  listHeight,
  maxReplenishments,
  onFilter,
  onScroll,
  scrollOffset,
  showModal,
  sortBy,
  stores,
  type,
}) => {
  const listRef = useRef()

  useSyncScroll(listRef, scrollOffset)

  return (
    <div className="table-replenishments">
      <TableReplenishmentsHeader className={headerClassName} onFilter={onFilter} sortBy={sortBy} type={type} />

      <List
        useIsScrolling
        className="table-replenishments-row"
        height={listHeight}
        itemCount={stores.length}
        itemData={{
          maxReplenishments,
          showModal,
          stores,
          type,
        }}
        itemSize={itemHeight}
        onScroll={onScroll}
        overscanCount={8}
        ref={listRef}
        width="100%"
      >
        {TableReplenishmentsRow}
      </List>
    </div>
  )
}

TableReplenishments.propTypes = {
  headerClassName: PropTypes.string,
  itemHeight: PropTypes.number,
  listHeight: PropTypes.number,
  maxReplenishments: PropTypes.number,
  onFilter: PropTypes.func,
  onScroll: PropTypes.func,
  scrollOffset: PropTypes.number,
  showModal: PropTypes.func,
  sortBy: PropTypes.object,
  stores: PropTypes.array,
  type: PropTypes.string,
}

export default TableReplenishments
